import { render } from "./trainItem.vue?vue&type=template&id=dc84e894&scoped=true&ts=true"
import script from "./trainItem.vue?vue&type=script&lang=ts"
export * from "./trainItem.vue?vue&type=script&lang=ts"

import "./trainItem.vue?vue&type=style&index=0&id=dc84e894&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/prod-hys-h5-5.0/hys-h5-5.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc84e894"]])

export default __exports__